import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M4826 8408 c58 -63 98 -96 114 -91 11 4 12 3 2 -4 -9 -7 50 -73 223
-245 l235 -235 298 299 c163 164 299 301 301 303 2 3 -267 5 -599 5 l-604 0
30 -32z"
          />
          <path
            d="M3220 6625 l0 -1805 228 0 227 0 108 108 107 107 0 1371 0 1370 -328
327 c-181 180 -332 327 -335 327 -4 0 -7 -812 -7 -1805z"
          />
          <path
            d="M7237 8092 l-327 -327 2 -1470 3 -1470 328 0 328 0 2 1797 c1 989 0
1798 -3 1798 -3 0 -152 -147 -333 -328z"
          />
          <path
            d="M4140 6467 c0 -570 1 -1037 3 -1037 2 0 153 148 335 329 l332 329 0
375 0 374 -331 329 c-181 181 -332 331 -335 333 -2 2 -4 -462 -4 -1032z"
          />
          <path
            d="M6220 6925 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"
          />
          <path d="M5070 6661 c0 -25 6 -27 13 -6 4 8 2 17 -3 20 -6 4 -10 -3 -10 -14z" />
          <path
            d="M5226 6515 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"
          />
          <path d="M5073 6440 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
          <path d="M5071 6354 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M4400 5269 c-223 -225 -413 -417 -422 -426 -17 -17 1 -18 412 -15
l430 2 0 425 c0 234 -3 424 -7 424 -5 -1 -190 -186 -413 -410z"
          />
          <path
            d="M2405 3941 c-39 -17 -29 8 -156 -410 l-53 -173 23 -19 c31 -25 70
-34 90 -22 9 6 23 32 31 59 8 27 19 55 23 62 9 13 154 17 173 4 6 -4 17 -30
23 -59 7 -29 19 -57 27 -64 19 -16 77 -3 99 21 18 20 17 24 -19 148 -21 70
-44 145 -51 167 -8 22 -28 87 -45 145 -18 58 -40 113 -50 123 -19 21 -85 31
-115 18z m74 -268 c13 -49 26 -96 28 -105 5 -16 -2 -18 -57 -18 -59 0 -62 1
-57 22 28 107 53 188 57 188 4 0 16 -39 29 -87z"
          />
          <path
            d="M4606 3939 c-61 -15 -103 -46 -125 -93 -53 -108 -8 -196 137 -266 81
-39 112 -66 112 -96 0 -62 -96 -75 -171 -24 -24 16 -50 30 -56 30 -25 0 -53
-39 -53 -74 0 -63 91 -111 205 -110 73 1 132 22 167 61 25 28 48 88 48 126 0
89 -48 151 -160 204 -41 19 -83 42 -92 51 -24 20 -23 59 1 72 29 15 103 12
145 -5 56 -24 96 10 84 72 -7 42 -155 74 -242 52z"
          />
          <path
            d="M5802 3943 c-33 -7 -44 -30 -107 -233 -114 -368 -114 -366 -55 -390
54 -22 76 -8 97 62 l19 63 69 3 c104 5 109 2 128 -68 20 -69 41 -81 101 -56
26 11 36 21 36 38 0 13 -37 144 -82 292 -81 265 -82 269 -115 282 -32 14 -48
15 -91 7z m94 -360 l6 -33 -54 0 c-30 0 -57 2 -60 5 -5 5 33 155 49 195 6 15
46 -100 59 -167z"
          />
          <path
            d="M7255 3941 c-32 -13 -40 -29 -68 -121 -14 -47 -50 -167 -81 -268 -30
-101 -52 -190 -49 -198 7 -18 55 -44 82 -44 24 0 30 9 56 80 l20 55 70 3 c104
4 110 1 124 -62 7 -30 19 -60 27 -66 29 -25 114 11 114 48 0 15 -46 170 -80
272 -10 30 -33 105 -51 166 -20 72 -38 115 -50 122 -25 16 -90 23 -114 13z
m79 -279 c14 -54 26 -102 26 -105 0 -4 -27 -7 -61 -7 -45 0 -60 3 -56 13 2 6
15 54 28 105 13 50 26 92 30 92 3 0 18 -44 33 -98z"
          />
          <path
            d="M8293 3935 c-22 -9 -34 -24 -41 -47 -5 -18 -42 -138 -81 -267 -39
-129 -71 -245 -71 -258 0 -18 9 -28 36 -39 65 -27 91 -7 109 82 4 21 13 34 28
38 31 8 140 7 153 -2 6 -4 20 -34 30 -67 15 -49 23 -61 42 -63 31 -5 80 16 92
37 8 15 -22 121 -147 520 -14 44 -22 56 -49 67 -41 17 -60 17 -101 -1z m83
-266 c35 -119 35 -119 -31 -119 -63 0 -64 3 -40 85 9 28 20 67 26 89 6 21 13
36 16 33 3 -3 16 -43 29 -88z"
          />
          <path
            d="M2852 3928 c-9 -9 -12 -90 -12 -305 0 -279 1 -293 19 -303 22 -11
310 -14 328 -2 18 11 25 55 14 85 l-11 27 -110 0 -110 0 0 243 c0 176 -3 246
-12 255 -7 7 -30 12 -53 12 -23 0 -46 -5 -53 -12z"
          />
          <path
            d="M3258 3924 c-16 -8 -28 -22 -28 -31 0 -8 41 -84 90 -167 l90 -153 0
-115 c0 -129 9 -148 69 -148 53 0 59 14 63 151 l3 124 93 149 c58 93 90 155
87 166 -11 34 -101 55 -122 28 -6 -7 -34 -59 -64 -115 -29 -57 -56 -103 -60
-103 -7 0 -77 117 -92 154 -29 72 -72 92 -129 60z"
          />
          <path
            d="M3872 3928 c-9 -9 -12 -77 -12 -245 0 -210 2 -238 19 -271 37 -73 94
-102 201 -102 96 0 151 26 188 89 27 46 27 47 31 269 4 261 1 272 -72 272 -24
0 -48 -5 -55 -12 -9 -9 -12 -75 -12 -235 0 -210 -1 -224 -20 -243 -27 -27
-100 -28 -123 -2 -15 16 -17 48 -17 233 0 250 -3 259 -74 259 -23 0 -47 -5
-54 -12z"
          />
          <path
            d="M5031 3926 c-9 -10 -11 -93 -9 -301 3 -270 4 -287 22 -301 27 -19 69
-18 95 4 19 15 21 29 23 137 l3 120 80 0 80 0 3 -120 c3 -141 12 -158 76 -153
64 5 66 13 66 330 0 264 -1 278 -19 288 -11 5 -34 10 -51 10 -66 0 -70 -8 -70
-135 l0 -115 -85 0 -85 0 0 115 c0 103 -2 115 -19 125 -28 15 -97 12 -110 -4z"
          />
          <path
            d="M6503 3929 c-16 -16 -18 -575 -3 -599 8 -12 36 -15 149 -15 139 0
139 0 183 30 72 51 78 73 78 280 0 168 -2 184 -22 225 -36 70 -75 84 -238 88
-99 2 -138 0 -147 -9z m259 -129 c16 -19 18 -42 18 -174 -1 -183 -3 -188 -90
-194 l-60 -4 0 194 c0 107 3 198 8 202 4 4 29 6 56 3 36 -3 55 -11 68 -27z"
          />
          <path
            d="M7610 3911 c-9 -24 -9 -35 2 -58 12 -26 18 -28 81 -31 l67 -3 0 -239
c0 -236 0 -239 22 -254 12 -9 34 -16 48 -16 14 0 36 7 48 16 22 15 22 18 22
255 l0 239 65 0 c58 0 66 3 81 25 13 20 15 33 7 58 l-9 32 -211 3 -210 2 -13
-29z"
          />
          <path
            d="M3976 2869 l-26 -31 2 -172 c3 -144 5 -171 18 -171 12 0 16 20 18
111 2 105 4 112 22 107 29 -8 70 5 70 22 0 9 -14 15 -42 17 -38 3 -43 6 -46
28 -4 39 19 73 56 82 47 12 42 38 -7 38 -32 0 -44 -6 -65 -31z"
          />
          <path
            d="M1374 2877 c-3 -8 20 -62 50 -120 54 -100 56 -108 56 -180 0 -61 3
-76 17 -81 25 -10 33 12 33 87 0 64 4 76 56 174 51 97 62 141 32 131 -7 -3
-33 -44 -59 -92 -25 -48 -50 -88 -54 -88 -5 0 -29 40 -54 88 -46 88 -66 109
-77 81z"
          />
          <path
            d="M3514 2855 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44
8z"
          />
          <path
            d="M4753 2863 c-10 -3 -13 -45 -13 -163 0 -137 2 -161 18 -180 24 -29
94 -34 100 -7 3 12 -3 17 -22 17 -42 0 -56 24 -56 98 0 37 4 72 8 77 4 6 20
10 37 10 20 0 31 6 33 17 2 13 -5 17 -35 20 l-38 3 -3 50 c-3 53 -9 65 -29 58z"
          />
          <path
            d="M4964 2855 c-4 -9 -2 -21 4 -27 15 -15 44 -1 40 19 -4 23 -36 29 -44
8z"
          />
          <path
            d="M5931 2861 c-19 -12 -6 -41 19 -41 15 0 20 7 20 25 0 26 -14 31 -39
16z"
          />
          <path
            d="M8134 2855 c-7 -18 3 -35 22 -35 20 0 30 30 13 41 -20 12 -29 11 -35
-6z"
          />
          <path
            d="M8854 2855 c-7 -18 3 -35 22 -35 20 0 30 30 13 41 -20 12 -29 11 -35
-6z"
          />
          <path
            d="M9017 2856 c-12 -30 -7 -292 6 -316 17 -34 57 -55 91 -46 35 9 29 26
-14 40 l-35 11 -3 83 -3 82 28 0 c15 0 34 4 42 9 22 14 3 31 -35 31 l-34 0 0
54 c0 45 -3 55 -19 59 -11 3 -22 -1 -24 -7z"
          />
          <path
            d="M3290 2701 c0 -138 2 -162 18 -181 24 -29 94 -34 100 -7 3 12 -3 17
-22 17 -42 0 -56 24 -56 98 0 37 4 72 8 77 4 6 20 10 37 10 20 0 31 6 33 17 2
13 -5 17 -35 20 l-38 3 -3 53 c-3 44 -6 52 -23 52 -18 0 -19 -8 -19 -159z"
          />
          <path
            d="M1718 2733 c-36 -23 -48 -53 -48 -119 0 -50 3 -59 34 -90 26 -26 42
-34 71 -34 29 0 45 8 71 34 31 31 34 40 34 91 0 87 -27 125 -93 132 -28 2 -51
-2 -69 -14z m102 -45 c43 -47 12 -158 -44 -158 -37 0 -59 34 -60 89 -1 81 57
119 104 69z"
          />
          <path
            d="M1994 2735 c-3 -8 -4 -53 -3 -101 4 -82 5 -87 37 -115 46 -41 103
-41 142 1 23 24 28 41 34 104 8 88 1 128 -23 124 -13 -3 -17 -21 -21 -96 -4
-78 -8 -96 -24 -108 -26 -18 -46 -18 -74 2 -20 13 -22 24 -22 94 0 43 -3 85
-6 94 -8 20 -33 21 -40 1z"
          />
          <path
            d="M2322 2623 c3 -106 6 -128 18 -128 12 0 16 19 21 88 7 98 23 127 71
127 21 0 28 5 28 20 0 26 -45 27 -73 3 -18 -17 -19 -17 -28 0 -6 9 -17 17 -25
17 -12 0 -14 -20 -12 -127z"
          />
          <path
            d="M2742 2731 c-15 -12 -22 -30 -22 -53 0 -40 9 -50 63 -69 46 -16 70
-40 61 -63 -9 -22 -76 -25 -102 -3 -17 13 -35 -4 -27 -25 12 -32 110 -39 143
-10 12 9 24 29 28 45 5 22 1 32 -22 53 -16 15 -45 32 -64 38 -68 21 -41 86 27
67 41 -12 66 4 39 24 -28 21 -98 19 -124 -4z"
          />
          <path
            d="M3018 2739 c-10 -5 -18 -16 -18 -24 0 -11 11 -13 48 -8 35 4 51 1 60
-9 16 -20 20 -64 5 -61 -29 6 -114 -20 -123 -37 -39 -73 35 -137 110 -96 21
12 26 12 36 -3 26 -33 36 2 32 107 -3 92 -5 101 -28 121 -27 22 -92 28 -122
10z m108 -144 c10 -26 -23 -65 -56 -65 -30 0 -57 30 -44 51 17 27 91 38 100
14z"
          />
          <path
            d="M3520 2621 c0 -72 3 -131 8 -131 28 1 33 20 30 136 -3 104 -5 119
-20 122 -16 3 -18 -8 -18 -127z"
          />
          <path
            d="M3695 2725 c-16 -15 -25 -36 -25 -55 0 -29 5 -34 65 -61 49 -22 65
-34 65 -49 0 -30 -37 -40 -88 -25 -50 15 -67 2 -32 -27 52 -42 160 -9 160 50
-1 39 -22 61 -77 81 -34 12 -49 23 -51 38 -5 31 29 46 73 34 41 -11 59 4 30
26 -31 22 -92 16 -120 -12z"
          />
          <path
            d="M4183 2737 c-33 -18 -15 -32 42 -32 43 0 51 -3 64 -27 9 -15 13 -29
11 -32 -6 -5 -54 -14 -86 -15 -30 -1 -64 -38 -64 -69 0 -64 64 -94 119 -56 22
16 24 16 33 1 4 -9 15 -14 23 -11 12 5 15 26 15 95 0 98 -11 131 -47 148 -31
14 -82 13 -110 -2z m115 -154 c4 -27 -48 -64 -78 -56 -38 10 -36 68 3 76 46
10 72 3 75 -20z"
          />
          <path
            d="M4499 2735 c-32 -17 -49 -61 -49 -122 0 -50 12 -80 44 -105 24 -20
84 -23 121 -6 30 14 30 45 0 40 -96 -16 -112 -8 -115 58 -3 68 -1 77 16 94 17
17 79 22 89 6 8 -12 35 -1 35 14 0 33 -94 46 -141 21z"
          />
          <path
            d="M4971 2741 c-10 -7 -12 -34 -10 -124 2 -63 7 -118 10 -121 3 -4 14
-4 23 0 14 6 16 22 14 127 -3 118 -8 136 -37 118z"
          />
          <path
            d="M5151 2719 c-29 -28 -31 -36 -31 -97 1 -69 8 -86 50 -115 41 -28 87
-22 126 17 31 31 34 40 34 90 0 67 -13 97 -50 119 -45 27 -94 22 -129 -14z
m111 -26 c13 -12 18 -31 18 -74 0 -48 -4 -60 -22 -73 -51 -36 -98 -1 -98 73 0
74 57 115 102 74z"
          />
          <path
            d="M5447 2743 c-9 -8 -9 -238 -1 -246 4 -3 15 -2 25 4 16 8 19 22 19 93
0 89 13 116 57 116 40 0 58 -36 61 -125 3 -61 8 -85 18 -89 22 -8 26 14 23
115 -4 85 -6 92 -32 115 -32 28 -88 32 -107 9 -12 -14 -15 -14 -30 0 -18 17
-24 18 -33 8z"
          />
          <path
            d="M5935 2738 c-3 -8 -4 -66 -3 -129 2 -93 6 -114 18 -114 13 0 15 20
15 124 0 91 -3 125 -12 128 -7 3 -15 -2 -18 -9z"
          />
          <path
            d="M6105 2725 c-29 -28 -32 -66 -7 -87 9 -9 39 -25 65 -37 40 -17 48
-24 45 -43 -3 -20 -9 -23 -48 -22 -25 0 -53 4 -62 8 -14 6 -18 4 -18 -13 0
-27 28 -41 84 -41 55 0 86 25 86 69 0 39 -25 65 -82 85 -33 12 -48 23 -48 35
0 26 42 42 82 30 18 -5 34 -9 35 -9 2 0 3 8 3 19 0 38 -99 43 -135 6z"
          />
          <path
            d="M6559 2733 c-32 -19 -49 -64 -49 -127 0 -41 5 -53 34 -82 36 -36 77
-44 119 -23 44 22 57 50 57 122 0 64 -2 71 -31 98 -36 34 -88 38 -130 12z
m101 -43 c29 -29 28 -116 -2 -141 -26 -23 -47 -24 -76 -3 -18 13 -22 25 -22
71 0 63 18 93 57 93 12 0 32 -9 43 -20z"
          />
          <path
            d="M6836 2735 c-12 -32 -6 -156 9 -185 34 -67 111 -81 167 -31 l33 29 0
99 c0 91 -1 98 -20 98 -18 0 -20 -8 -25 -95 -5 -90 -6 -95 -32 -110 -25 -13
-31 -13 -55 0 -27 15 -28 20 -33 110 -4 77 -8 95 -21 98 -9 2 -19 -4 -23 -13z"
          />
          <path
            d="M7167 2743 c-4 -3 -7 -59 -7 -124 0 -106 2 -117 19 -122 24 -6 31 16
31 104 0 76 12 98 60 108 21 4 35 13 35 21 0 21 -42 24 -70 6 -30 -20 -35 -20
-35 -1 0 15 -21 21 -33 8z"
          />
          <path
            d="M7570 2559 c0 -176 1 -190 18 -187 14 3 18 16 20 71 2 49 7 67 17 67
8 0 17 -4 20 -10 20 -32 108 6 125 53 24 70 6 153 -39 180 -34 20 -60 21 -97
5 -22 -10 -28 -10 -32 0 -2 6 -10 12 -18 12 -12 0 -14 -33 -14 -191z m144 132
c13 -14 16 -33 14 -77 -3 -52 -6 -60 -30 -74 -25 -13 -31 -13 -55 0 -24 14
-28 23 -31 69 -4 66 16 101 57 101 15 0 36 -8 45 -19z"
          />
          <path
            d="M7894 2737 c-2 -7 -3 -65 -2 -128 2 -93 6 -114 18 -114 12 0 16 19
21 88 7 98 16 115 70 126 44 9 45 35 3 39 -20 2 -38 -3 -49 -14 -16 -16 -18
-16 -27 -1 -11 20 -27 22 -34 4z"
          />
          <path
            d="M8137 2743 c-4 -3 -7 -59 -7 -124 0 -90 3 -118 14 -122 28 -11 36 17
36 123 0 69 -4 110 -12 118 -14 14 -22 15 -31 5z"
          />
          <path
            d="M8327 2727 c-35 -29 -48 -74 -38 -139 10 -63 46 -98 101 -98 65 0
110 56 110 135 0 102 -100 161 -173 102z m108 -41 c11 -16 15 -41 13 -77 -3
-46 -7 -55 -30 -69 -25 -13 -31 -13 -55 0 -24 14 -28 23 -31 69 -4 67 16 101
58 101 20 0 35 -8 45 -24z"
          />
          <path
            d="M8614 2737 c-2 -7 -3 -65 -2 -128 2 -93 6 -114 18 -114 12 0 16 19
21 88 7 98 16 115 70 126 44 9 45 35 3 39 -20 2 -38 -3 -49 -14 -16 -16 -18
-16 -27 -1 -11 20 -27 22 -34 4z"
          />
          <path
            d="M8857 2743 c-4 -3 -7 -59 -7 -124 0 -90 3 -118 14 -122 28 -11 36 17
36 123 0 69 -4 110 -12 118 -14 14 -22 15 -31 5z"
          />
          <path
            d="M9220 2729 c0 -12 18 -65 41 -117 30 -72 39 -103 35 -127 -6 -33 -37
-67 -69 -79 -22 -7 -17 -30 8 -34 29 -6 65 20 86 60 29 57 109 276 109 299 0
14 -5 19 -17 17 -12 -2 -28 -31 -48 -85 -17 -45 -33 -84 -36 -87 -3 -4 -21 33
-40 81 -23 58 -40 89 -51 91 -13 2 -18 -3 -18 -19z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
